export const sourceTypeList = (state) => state.sourceTypeList;
